import { IconSVG } from '../types';

export const Body = ({ size, style }: IconSVG) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 18 20"
      style={style}
    >
      <path
        fill="currentColor"
        d="M9 4c-.55 0-1.021-.196-1.413-.587A1.926 1.926 0 017 2c0-.55.196-1.02.587-1.413A1.926 1.926 0 019 0c.55 0 1.02.196 1.412.588C10.804.979 11 1.45 11 2c0 .55-.196 1.02-.588 1.413A1.926 1.926 0 019 4zM6 19V7a43.202 43.202 0 01-2.475-.275 28.905 28.905 0 01-2.45-.45A1.135 1.135 0 01.387 5.8.893.893 0 01.25 5a.982.982 0 01.525-.625c.266-.133.55-.167.85-.1 1.166.25 2.379.433 3.637.55C6.521 4.942 7.766 5 9 5c1.233 0 2.479-.058 3.737-.175a31.02 31.02 0 003.638-.55c.3-.067.583-.033.85.1A.982.982 0 0117.75 5a.893.893 0 01-.138.8c-.175.25-.404.408-.687.475-.8.183-1.617.333-2.45.45-.833.117-1.659.208-2.475.275v12c0 .283-.096.52-.288.712A.968.968 0 0111 20a.968.968 0 01-.713-.288A.968.968 0 0110 19v-5H8v5c0 .283-.096.52-.288.712A.967.967 0 017 20a.967.967 0 01-.713-.288A.968.968 0 016 19z"
      />
    </svg>
  );
};
